// extracted by mini-css-extract-plugin
export default {"mainRow":"ExpandableCard_mainRow__EwIm1","expandedRow":"ExpandableCard_expandedRow__54Rc5","loader":"ExpandableCard_loader__-Zfn0","indent":"ExpandableCard_indent__Y0Y95"};